import { createContext, useContext } from 'react';

import type { Carousel, Recommender } from '@coursera/event-pulse-types';

import type { SkillCareerRoleFragment as CareerRoleFragment } from 'bundles/unified-description-page-common/queries/__generated__/CareerRolesQuery';

export type CareerRolesDataContextType = {
  loading?: boolean;
  data?: Array<CareerRoleFragment>;
  eventingPathwaysData?: {
    recommender?: Recommender;
    carousel?: Carousel;
  };
};

const CareerRolesDataContext = createContext<CareerRolesDataContextType | undefined>(undefined);

export const useCareerRolesData = () => {
  return useContext(CareerRolesDataContext) || {};
};

export default CareerRolesDataContext;
